<template>
  <div class="simplepage-container">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-content">
        <img
          src="@/assets/home_main.jpg"
          alt="청년주택 대표 이미지"
          class="hero-image"
        />
      </div>
    </section>

    <!-- Premium Section (Intro) -->
    <section class="premium-section">
      <div class="intro-content">
        <div class="premium-list-title">
          <span class="main"
            ><span class="accent">BX201 서울대청년안심주택</span></span
          >
          <span class="desc"
            >의 <span class="num-accent">프리미엄</span></span
          >
        </div>
        <div class="premium-list">
          <div class="premium-row" v-for="(item, i) in premiumList" :key="i">
            <div class="premium-left">
              <div class="premium-premium">PREMIUM</div>
              <div class="premium-number" :class="`color${i + 1}`">
                {{ i + 1 }}
              </div>
            </div>
            <div class="premium-right">
              <div class="premium-title">{{ item.title }}</div>
              <div class="premium-desc-list">
                <div
                  v-for="(line, idx) in item.desc"
                  :key="`desc-${i}-${idx}`"
                  class="premium-desc"
                >
                  {{ line }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Contact Us Section -->
      <div class="cta-background">
        <div class="container">
          <h1 class="cta-title">Contact Us</h1>
          <h2 class="cta-phone">02-3285-0201</h2>
          <p class="cta-hours">
            운영 시간: 10:00 ~ 17:00 (주말 및 공휴일 제외)
          </p>
          <p class="cta-hours">점심 시간: 12:00 ~ 14:00</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import axios from '@/utils/axios'

onMounted(() => {
  /* ▶ 팝업 실행 */
  fetchAndOpenPopups()
})

async function fetchAndOpenPopups() {
  try {
    const { data } = await axios.get('/api/bx201/popup/active') // 활성 팝업 목록
    const now = Date.now()
    let visiblePopupIndex = 0

    data.forEach((popup) => {
      const key = `popup-hidden-${popup.id}`
      const stored = localStorage.getItem(key)

      let shouldShow = true
      if (stored) {
        try {
          const { expires } = JSON.parse(stored)
          if (now < expires) shouldShow = false // 아직 숨김 유지
          else localStorage.removeItem(key) // 만료 → 정리
        } catch {
          localStorage.removeItem(key) // 파싱 오류 → 정리
        }
      }

      if (shouldShow) {
        openPopup(popup.id, visiblePopupIndex)
        visiblePopupIndex += 1
      }
    })
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[popup] fetch failed:', err)
  }
}

const POPUP_WIDTH = 520
const POPUP_HEIGHT = 720
const POPUP_GAP = 12
const POPUP_MARGIN = 40

function getPopupPosition(index, width, height) {
  const screen = window.screen || {}
  const availLeft = Number.isFinite(screen.availLeft) ? screen.availLeft : 0
  const availTop = Number.isFinite(screen.availTop) ? screen.availTop : 0
  const availWidth = screen.availWidth || window.innerWidth || width
  const usableWidth = Math.max(width, availWidth - (POPUP_MARGIN * 2))
  const maxColumns = Math.max(1, Math.floor((usableWidth + POPUP_GAP) / (width + POPUP_GAP)))
  const column = index % maxColumns
  const row = Math.floor(index / maxColumns)

  return {
    left: availLeft + POPUP_MARGIN + (column * (width + POPUP_GAP)),
    top: availTop + POPUP_MARGIN + (row * (height + POPUP_GAP)),
  }
}

function openPopup(id, index = 0) {
  const url = `${window.location.origin}/popup/${id}`
  // 창 크기 & 겹침 방지용 위치 오프셋
  const width = POPUP_WIDTH
  const height = POPUP_HEIGHT
  const { left, top } = getPopupPosition(index, width, height)
  // 창 이름을 유니크하게 만들어 여러 개 동시 오픈 (id+timestamp)
  const name = `popup-${id}-${Date.now()}`
  window.open(url, name, `width=${width},height=${height},left=${left},top=${top},resizable=yes`)
}

const premiumList = [
  {
    num: 1,
    title: '슬세권 인프라 프리미엄',
    desc: [
      '- 편의점, 스타벅스, 은행, 병원 등 다양한 편의시설',
      // 여러 줄 가능
    ],
  },
  {
    num: 2,
    title: '통학 편의성 프리미엄',
    desc: ['- 서울대, 숭실대 접근 용이'],
  },
  {
    num: 3,
    title: '교통 프리미엄',
    desc: [
      '- 지하철 2호선 서울대입구역 도보 1분 거리',
      '- 강남권 출근 20분 이내',
    ],
  },
  {
    num: 4,
    title: '입주 프리미엄',
    desc: [
      '- 냉장고, 에어컨, 세탁기, 전열교환기, 전자레인지, 쿡탑(하이라이트) 빌트인 가전 제공',
    ],
  },
  // {
  //   num: 5,
  //   title: "금융지원",
  //   desc: [
  //     "- 서울주택도시공사 보증금 50% 지원 (최대 4,500만원)",
  //   ],
  // },
]
</script>

<style scoped>
/* 전체 컨테이너 */
.simplepage-container {
  width: 100%;
  background: #fff;
  padding: 0;
  margin: 0;
}

/* Hero Section */
.hero-section {
  padding-top: 100px;
  background: #fff;
}

.hero-content {
  width: 100%;
  background: #fff;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: auto;
  display: block;
}

/* Premium Section */
.premium-section {
  width: 100%;
  /* background: #f7f7f7; */
  padding: 80px 0 0 0;
}

.intro-content {
  max-width: 1200px;
  width: 90%;
  margin: 0 auto;
  padding: 40px 0 0 0;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.premium-list {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.premium-list-title {
  font-size: 4rem;
  text-align: center;
  font-weight: bold;
  margin-bottom: 2.5rem;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
}

.premium-list-title .main {
  font-weight: bold;
}
.premium-list-title .accent {
  color: #2272bd;
  font-weight: bold;
  font-size: 4rem;
}
.premium-list-title .desc {
  font-weight: 400;
  font-size: 1.2rem;
  color: #87704c;
}
.premium-list-title .num-accent {
  color: #b98b2a;
  font-weight: bold;
  font-size: 1.4rem;
}
.premium-list {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.premium-row {
  display: flex;
  flex-direction: row; /* 무조건 row! */
  border-bottom: 1px solid #eee;
  padding: 40px 0;
  align-items: stretch;
  background: #fff;
}
.premium-left {
  min-width: 86px;
  max-width: 86px;
  width: 86px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-right: 24px;
}
.premium-premium {
  font-family: 'Montserrat', 'Pretendard', sans-serif;
  font-weight: 500;
  font-style: italic;
  font-size: 1.18rem;
  color: #b5b5b5;
  letter-spacing: 1.5px;
  margin-bottom: 8px;
}
.premium-number {
  font-size: 8rem;
  font-weight: 900;
  font-family: 'Montserrat', 'Pretendard', sans-serif;
  line-height: 1;
  margin-bottom: 4px;
  margin-top: 0;
}
.premium-number.color1 {
  color: #766553;
}
.premium-number.color2 {
  color: #f7b531;
}
.premium-number.color3 {
  color: #6c6057;
}
.premium-number.color4 {
  color: #e9ad36;
}
.premium-number.color5 {
  color: #3580ad;
}
.premium-right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.premium-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 10px;
}
.premium-title .color1 {
  color: #766553;
}
.premium-title .color2 {
  color: #f7b531;
}
.premium-title .color3 {
  color: #6c6057;
}
.premium-title .color4 {
  color: #e9ad36;
}
.premium-title .color5 {
  color: #3580ad;
}
.premium-desc-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 36px;
  align-items: flex-start;
}
.premium-desc {
  font-size: 1.1rem;
  color: #4a4a4a;
  font-weight: bold;
  flex: 1 1 340px;
  margin-bottom: 5px;
}
.premium-desc.right {
  text-align: right;
  color: #87704c;
  font-weight: 500;
  font-weight: bold;
  flex: none;
}
/* CTA Section */
.cta-background {
  background-color: rgba(0, 36, 71, 0.85);
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  width: 100%;
  min-height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  margin-top: 40px;
  padding: 60px 0 50px 0;
}

.container {
  max-width: 1200px;
  width: 90%;
  padding: 0;
  margin: 0 auto;
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 16px;
}

.cta-phone {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.cta-hours {
  font-size: 1rem;
  font-weight: 400;
  margin-top: 4px;
  color: #d1d1d1;
}

/* 반응형 */
@media (max-width: 900px) {
  .hero-content,
  .hero-image {
    min-height: 500px;
    height: 60vh;
    max-height: 60vh;
  }
  .premium-row {
    flex-direction: row;
    align-items: flex-start;
    padding: 24px 0;
    min-height: unset;
  }
  .premium-left {
    min-width: 60px;
    max-width: 60px;
    width: 60px;
    margin-right: 16px;
  }
  .premium-number {
    margin-top: 0;
    font-size: 5rem;
    margin-left: 8px;
  }
  .premium-premium {
    font-size: 1rem;
    margin-right: 10px;
    margin-bottom: 0;
  }
  .premium-right {
    width: 100%;
    display: block;
  }
  /* .premium-list-title { font-size: 2.2rem; } */
  .premium-list-title .accent {
    font-size: 2rem;
  }
  .premium-desc,
  .premium-desc.right {
    font-size: 0.97rem;
    width: 100%;
    margin: 0 0 2px 0 !important;
    line-height: 1.32 !important;
    padding: 0 !important;
    min-height: unset !important;
    height: auto !important;
    flex: none !important;
  }
  .premium-desc-list {
    gap: 0.12rem !important;
    align-items: flex-end !important;
    flex-direction: column;
  }
}
@media (max-width: 600px) {
  .hero-content {
    min-height: 180px;
    height: auto;
    max-height: 48vh;
    padding-top: 0;
  }
  .hero-image {
    min-height: 180px; /* 옵션, 진짜 너무 작아질 때만 */
    height: auto;
  }
  .premium-section {
    padding: 32px 0 0 0;
  }
  .intro-content {
    padding: 24px 0 0 0;
  }
  .premium-list-title {
    font-size: 1.2rem;
  }
  .premium-number {
    font-size: 2.2rem;
  }
  .premium-premium {
    font-size: 1.1rem;
  }
  .premium-title {
    font-size: 1rem;
  }
  .premium-desc {
    font-size: 0.93rem;
  }
  .premium-row {
    padding: 14px 0 !important;
  }
  .cta-title {
    font-size: 1.8rem;
  }
  .cta-phone {
    font-size: 1.2rem;
  }
  .premium-list-title .accent {
    font-size: 1.2rem;
  }
}

/* (모바일 레이아웃 부드럽게) */
@media (max-width: 600px) {
  .premium-desc,
  .premium-desc.right {
    line-height: 1.23 !important;
    padding: 0 !important;
    margin: 0 0 2px 0 !important;
    min-height: unset !important;
    height: auto !important;
    flex: none !important;
    width: 100% !important;
  }
  .premium-desc-list {
    gap: 0.1rem !important;
    align-items: flex-end !important;
  }

  .premium-list-title {
    font-size: 1.25rem;
  }
}
</style>
